export default __webpack_public_path__ + "static/media/element_17.b2d6518a.jpg";